import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface IpanelSlider {
  open: boolean;
  UIComponent: string;
}
const initialState: IpanelSlider = {
  open: false,
  UIComponent: '',
};
const panelSlider = createSlice({
  name: 'panelslider',
  initialState: initialState,
  reducers: {
    openPanel: (state, action: PayloadAction<string>) => {
      state.open = true;
      state.UIComponent = action.payload;
    },
    closePanel: (state) => {
      state.open = false;
    },
  },
});
export const { openPanel, closePanel } = panelSlider.actions;
export default panelSlider.reducer;
